import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Package, Clock, ShieldCheck, ArrowRight } from "lucide-react";

const FEATURES = [
  { Icon: Leaf,        title: "Premium Ingredients",     text: "Sourced from the finest fragrance houses worldwide, ensuring exceptional quality in every drop." },
  { Icon: Clock,       title: "Long-Lasting Scents",     text: "Designed to leave an unforgettable impression that carries through your entire day and night." },
  { Icon: Package,     title: "Elegant Packaging",       text: "Meticulously crafted collector designs that elevate the unboxing experience from the very first touch." },
  { Icon: ShieldCheck, title: "Authenticity Guaranteed", text: "100% genuine designer perfumes sourced directly from authorized distributors worldwide." },
];

function FeatureCard({ Icon, title, text }) {
  return (
    <div className="flex gap-4 group">
      <div className="shrink-0 w-11 h-11 rounded-sm bg-brand-cream flex items-center justify-center group-hover:bg-brand-red transition-colors duration-300">
        <Icon size={19} className="text-brand-red group-hover:text-white transition-colors duration-300" />
      </div>
      <div>
        <h3 className="font-display text-xl text-brand-charcoal mb-2">{title}</h3>
        <p className="font-body text-sm text-gray-400 leading-relaxed">{text}</p>
      </div>
    </div>
  );
}

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <span className="section-label">Our Promise</span>
          <h2 className="section-title mt-3 mb-4">Why Choose Tiwani</h2>
          <p className="font-body text-gray-400 text-sm max-w-md mx-auto leading-relaxed">
            Experience the beauty of authentic luxury perfumes that define elegance, curated just for you.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center">
          <div className="flex flex-col gap-10">
            {FEATURES.slice(0, 2).map((f, i) => <FeatureCard key={i} {...f} />)}
          </div>

          <div className="flex justify-center">
            <div className="relative w-64 h-80">
              <div className="absolute inset-0 bg-brand-cream rounded-sm" />
              <img
                src="https://res.cloudinary.com/dirgb6nie/image/upload/v1775254802/19a4f554-b2bc-4857-a59c-8cd5237cbeea_gwg6yo.jpg"
                alt="Tiwani signature scent"
                className="relative z-10 w-full h-full object-cover rounded-sm shadow-2xl"
                loading="eager"
                fetchPriority="high"
                onError={(e) => { e.currentTarget.src = "https://img.freepik.com/free-psd/amber-perfume-bottle-elegant-fragrance-luxurious-glass-container_191095-85650.jpg?semt=ais_incoming&w=740&q=80"; }}
              />
              <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-brand-red/15 rounded-sm z-0" />
            </div>
          </div>

          <div className="flex flex-col gap-10">
            {FEATURES.slice(2).map((f, i) => <FeatureCard key={i} {...f} />)}
          </div>
        </div>

        <div className="text-center mt-16">
          <Link to="/products" className="btn-primary group">
            Shop Now
            <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
          </Link>
        </div>
      </div>
    </section>
  );
}
